import React from 'react'
import onlineIcon from '../../Icons/onlineIcon.png';
import closeIcon from '../../Icons/closeIcon.png';
import './Infobar.css';

import '../chat/Chat';
const Infobar = ({room,name}) =>

(      <div className="infoBar">
            <div className="leftInnerContainer">
                 <img className="onlineIcon" src={onlineIcon} alt="online icon"/>
                  <div>
                 <h2>{room} By: {name}</h2>
                    
                  </div>
            </div>

            <div className="rightInnerContainer">
               <a href='/'><img src={closeIcon} alt="close icon"/></a>
            </div>
            
        </div>
    
);

export default Infobar;
